import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import StatsBand from "@/components/StatsBand";
import ServicesSection from "@/components/ServicesSection";
import WhoWeServeSection from "@/components/WhoWeServeSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import CrewEstimator from "@/components/CrewEstimator";
import DifferentiatorsSection from "@/components/DifferentiatorsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import RequestTalentForm from "@/components/RequestTalentForm";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";
import JobSeekerDialog from "@/components/JobSeekerDialog";
import AdminPage from "@/pages/AdminPage";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const Home = () => {
  const [prefill, setPrefill] = useState(null);
  const [jobOpen, setJobOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#090A0F] text-white overflow-x-hidden">
      <Navbar
        onRequestStaff={() => scrollTo("request")}
        onJoinCrew={() => setJobOpen(true)}
      />
      <main>
        <HeroSection
          onQuote={() => scrollTo("request")}
          onEstimator={() => scrollTo("estimator")}
        />
        <StatsBand />
        <ServicesSection />
        <WhoWeServeSection />
        <HowItWorksSection />
        <CrewEstimator
          onApply={(data) => {
            setPrefill(data);
            scrollTo("request");
          }}
        />
        <DifferentiatorsSection />
        <TestimonialsSection />
        <RequestTalentForm
          prefill={prefill}
          onJoinCrew={() => setJobOpen(true)}
        />
        <FaqSection />
      </main>
      <Footer onJoinCrew={() => setJobOpen(true)} />
      <JobSeekerDialog open={jobOpen} onOpenChange={setJobOpen} />
      <Toaster richColors position="top-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
